import React, { Component } from 'react';
import Modal from '../../global/modal/modal';
import Button from '../../global/button/button';
import TextField from '../../global/text_field/text_field';
import DateField from '../../global/date_field/date_field';
import { updateObject } from '../../global/utility';
import logger from '../../global/logger';

class ItemEditorModal extends Component {

    constructor(props) {
        super(props);
    }

    state = {
        item: null,
    }

    componentDidMount() {
        logger.log(this.props.item);
        this.updateStateItem(this.props.item);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.item !== this.props.item) {
            logger.log(this.props.item);
            this.updateStateItem(this.props.item);
        }
    }

    formatDate(date) {
        if (date == null) {
            return null;
        }
        const dateOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const timeOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
        let dateString = new Intl.DateTimeFormat('en-CA', dateOptions).format(date);
        let timeString = new Intl.DateTimeFormat('en-CA', timeOptions).format(date);
        return `${dateString}T${timeString}`;
    }

    invertDate(date) {
        if (date == null) {
            return null;
        }
        return new Date(date).toISOString();
    }

    saveItem() {
        let updatedItem = updateObject(this.state.item, {
            start_date: this.invertDate(this.state.item.start_date),
            end_date: this.invertDate(this.state.item.end_date),
        });
        logger.log("saving item: " + JSON.stringify(updatedItem));
        this.props.onSave(updatedItem, () => {
            logger.log("saved item");
            Modal.dismissModal();
        });
    }

    updateStateItem(item) {
        if (item.billboard_media_item != null) {
            item = item.billboard_media_item;
        }
        let updatedStartDate = item.start_date ? new Date(item.start_date) : null;
        let updatedEndDate = item.end_date ? new Date(item.end_date) : null;
        logger.log(updatedStartDate);
        logger.log(updatedEndDate);
        let formattedStartDate = this.formatDate(updatedStartDate);
        let formattedEndDate = this.formatDate(updatedEndDate);
        logger.log(formattedStartDate);
        logger.log(formattedEndDate);

        let updatedItem = updateObject(item, {
            start_date: formattedStartDate,
            end_date: formattedEndDate,
        });
        this.setState(updateObject(this.state, {
            item: updatedItem,
        }));
    }
    
    changeHandler(event, property_name) {
        logger.log("changeHandler: " + property_name + " " + event.target.value);
        var newValue = event.target.value;
        if (property_name == "start_date" || property_name == "end_date") {
            newValue = this.formatDate(new Date(newValue));
        }
        var updatedItem = updateObject(this.state.item, {
            [property_name]: newValue,
        });
        this.setState(updateObject(this.state, {
            item: updatedItem,
        }));
    }

    isPlaylistItem() {
        return this.props.item.billboard_media_item != null && this.props.item.url != null;
    }

    shouldDeleteFromPlaylist() {
        return this.props.item.url == null
    }

    render() {

        if (this.state && this.state.item == null) {
            return <div>Loading...</div>;
        }

        var date_fields = (
            <div>
                <DateField label="Start Date" property_name="start_date" value={this.state.item.start_date} changeHandler={(event) => this.changeHandler(event, "start_date")} placeholder="Enter a start date" />
                <DateField label="End Date" property_name="end_date" value={this.state.item.end_date} changeHandler={(event) => this.changeHandler(event, "end_date")} placeholder="Enter an end date" />
            </div>
        )

        return (
            <div>
                <div className="float-left w-1/4 m-0">
                    <img src={this.state.item.url } alt={this.state.item.title} className="w-full h-full rounded-lg" draggable={false} />
                </div>
                <div className="float-right w-3/4 m-0 p-4">
                    <TextField label="Name" property_name="title" value={this.state.item.title} changeHandler={(event) => this.changeHandler(event, "title")} placeholder="Enter a name" />
                    
                    {date_fields}
                </div>
                <div className="clear-both"></div>
                <div className="flex justify-end">
                    <Button text="Save" clickEvent={() => this.saveItem()} />
                    <div className="w-4"></div>
                    <Button text="Cancel" clickEvent={() => Modal.dismissModal()} />
                    <div className="w-4"></div>
                    <Button text={this.shouldDeleteFromPlaylist() ? "Remove from playlist" : "Delete media"} clickEvent={() => this.props.onDelete(this.props.item, () => {
                        Modal.dismissModal();
                    })} />
                </div>
            </div>
        );
    }
}

export default ItemEditorModal;